
(function () {
  function snapToStep(input) {
    if (!input || input.type !== 'number') return;

    var step = parseInt(input.getAttribute('step'), 10);
    if (!step || step < 2) return;

    var min = parseInt(input.getAttribute('min'), 10);
    if (!min || min < step) min = step;

    var max = parseInt(input.getAttribute('max'), 10);
    var value = parseInt(input.value, 10);

    if (isNaN(value) || value < min) value = min;

    var snapped = min + Math.round((value - min) / step) * step;

    if (snapped < min) snapped = min;
    if (!isNaN(max) && snapped > max) {
      snapped = min + Math.floor((max - min) / step) * step;
      if (snapped < min) snapped = min;
    }

    if (String(snapped) !== input.value) input.value = String(snapped);
  }

  function handle(event) {
    var target = event.target;
    if (target && target.classList && target.classList.contains('qty')) snapToStep(target);
  }

  document.addEventListener('change', handle, true);
  document.addEventListener('blur', handle, true);

  // Vangnet: aantal getypt en direct op 'in winkelwagen' geklikt zonder change-event.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelectorAll) return;
      Array.prototype.forEach.call(form.querySelectorAll('input.qty'), snapToStep);
    },
    true
  );
})();
